const fonts = {
    family: {
        body: `'EB Garamond', sans-serif`,
        heading: `'Quicksand', sans-serif`
    }
}

export default fonts